import { render } from "./index.vue?vue&type=template&id=22c69cfa&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=22c69cfa&lang=less&scoped=true"
import "@/style/manga-list.less?vue&type=style&index=1&id=22c69cfa&scoped=true&lang=less"
import "@/style/chapter-list.less?vue&type=style&index=2&id=22c69cfa&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c69cfa"],['__file',"src/views/collect/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22c69cfa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22c69cfa', __exports__)) {
    console.log('reload')
    api.reload('22c69cfa', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=22c69cfa&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('22c69cfa', render)
  })

}


export default __exports__